export default [
  {
    path: "/cancelamento/",
    name: "Cancelamento",
    component: () =>
      import(
        /* webpackChunkName: "analise-venda" */
        "../views/Cancelamento/ListaCancelamento.vue"
      ),
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
];
